import React from "react";
import { Icon } from "@iconify/react";

// Shown to anyone who is not a super admin, or when the server says no (403).
const NotAllowedCard = ({ message }) => (
  <div className="card radius-12">
    <div className="card-body p-24 d-flex align-items-start gap-3">
      <span
        className="w-40-px h-40-px radius-8 d-flex justify-content-center align-items-center flex-shrink-0"
        style={{ background: "rgba(140, 80, 253, 0.08)", border: "1px solid rgba(140, 80, 253, 0.18)" }}
      >
        <Icon icon="mdi:lock-outline" style={{ fontSize: "1.25rem", color: "#8C50FD" }} />
      </span>
      <div>
        <h6 className="fw-semibold mb-1">Giveaways are for super admins only</h6>
        <p className="text-sm text-secondary-light mb-0">
          {message || "Your account cannot open this page. Ask a super admin if you need something here."}
        </p>
      </div>
    </div>
  </div>
);

export default NotAllowedCard;
